import { render, staticRenderFns } from "./RegistrationNumber.vue?vue&type=template&id=3553d710&"
import script from "./RegistrationNumber.vue?vue&type=script&lang=js&"
export * from "./RegistrationNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports